import { useContext, useEffect } from 'react'
import { NavContext } from '../../../../../context/global_context'
import DtcMappingItem from '../../DtcMappingItem'
import {
  createSearchParams,
  useParams,
  useSearchParams,
} from 'react-router-dom'
import { getRequest } from '../../../../../services/base'

const DTCMappingSection = ({}) => {
  const [value, dispatch] = useContext(NavContext)

  let { vehicle } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    getDtcsDetails()
  }, [])

  const getDtcsDetails = async () => {
    let res = await getRequest(
      `/api/dtcs/mappings/?${createSearchParams({
        dtc_id: searchParams.getAll('dtc_id'),
      })}&vehicle=${vehicle}`
    )
    if (res?.data?.length > 0) {
      let destination_only = false
      if (res?.data?.length > 0) {
        res?.data.forEach((dtcs_obj) => {
          if (dtcs_obj.destination_only) {
            destination_only = true
          }
        })
      }
      dispatch({
        type: 'header',
        data: {
          header: 'Admin Tools',
          sub_header: `Vehicle List / ${vehicle} / DTCs / Tracer Authoring Mappings / DTC Mapping`,
          id: '',
          show_back_btn: true,
          dtc_details: res.data,
          vehicle: vehicle,
          back_btn_url: `/vehicles/${vehicle}/dtcs/listing`,
          destination_only: destination_only,
        },
      })
    }
  }

  return (
    <div className="flex-1 w-1/3 flex flex-col px-4 py-2 bg-tracer-dark-blue flex-grow">
      <div className="flex-grow flex flex-col">
        <h2 className="text-white text-xl mb-2">DTC Mappings</h2>
        <div className="flex-auto h-0 overflow-y-auto">
          {value?.dtc_details?.map((row, index) => {
            return (
              <DtcMappingItem
                key={`dtc_mapping_item-${index}-${row.id}`}
                {...row}
                destroyAllByDtcUrl={() => {}}
                onDtcMappingChange={() => {
                  getDtcsDetails()
                }}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DTCMappingSection
